import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b54b90a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "pageList",
  class: "CxList"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("品牌：")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("车型名称：")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"var(--el-color-primary)"} }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-bianji" }),
  /*#__PURE__*/_createTextVNode("  编辑")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"var(--el-color-danger)"} }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-shanchu" }),
  /*#__PURE__*/_createTextVNode("  删除 ")
], -1))
const _hoisted_6 = { style: {"text-align":"center","padding":"10px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "将所选车型及该车型关联的车辆手册转移到以下品牌:", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ListEngine = _resolveComponent("ListEngine")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ListEngine, {
        pageList: _ctx.pageList,
        ref: "pageListRef",
        onBatchDelHandler: _ctx.batchDelHandler,
        onBatchMoveHandler: _ctx.batchMoveHandler,
        setDelNoteMsg: _ctx.setDelNoteMsg
      }, {
        queryParams: _withCtx(() => [
          _createVNode(_component_el_row, { class: "myRow" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 3,
                class: "myColTitle"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 9 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    ref: el=>_ctx.refMap.set('brandId',el),
                    modelValue: _ctx.pageList.queryParam.brandId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageList.queryParam.brandId) = $event)),
                    placeholder: "请选择品牌",
                    clearable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comboSelect({comboId:'brandId'}), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 3,
                class: "myColTitle"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 9 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入车型名称进行模糊匹配查询...",
                    modelValue: _ctx.pageList.queryParam.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageList.queryParam.name) = $event)),
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        fixCol: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            "header-align": "center",
            align: "center",
            label: "操作",
            width: "150"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.pageListRef.editHandler(scope.row)),
                type: "text"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.pageListRef.deleteHandler(scope.row)),
                type: "text"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        tbCols: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "F_BRAND_ID",
            label: "品牌"
          }),
          _createVNode(_component_el_table_column, {
            prop: "F_NAME",
            label: "车型名称"
          }),
          _createVNode(_component_el_table_column, {
            prop: "F_TIME",
            label: "修改时间"
          }),
          _createVNode(_component_el_table_column, {
            prop: "F_USER_ID",
            label: "修改人"
          })
        ]),
        _: 1
      }, 8, ["pageList", "onBatchDelHandler", "onBatchMoveHandler", "setDelNoteMsg"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.otherParams.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.otherParams.dialogVisible) = $event)),
      "append-to-body": true,
      draggable: "",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.otherParams.dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.sureBatchMoveHandler
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_select, {
            ref: el=>_ctx.refMap.set('brandId',el),
            modelValue: _ctx.otherParams.moveBrandId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.otherParams.moveBrandId) = $event)),
            placeholder: "请选择品牌",
            clearable: "",
            style: {"width":"80%","margin-top":"10px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comboSelect({comboId:'brandId'}), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}